// src/utils/i18n.ts

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod/v4';
import { en as zodEn, ru as zodRu } from 'zod/v4/locales';

// Russian translation imports
import _401Ru from '@/locales/ru/401.json';
import _404Ru from '@/locales/ru/404.json';
import accessRulesRu from '@/locales/ru/access-rules.json';
import accessRu from '@/locales/ru/access.json';
import attacksRu from '@/locales/ru/attacks.json';
import celeryRu from '@/locales/ru/celery.json';
import changePasswordRu from '@/locales/ru/change-password.json';
import codemirrorRu from '@/locales/ru/codemirror.json';
import componentsRu from '@/locales/ru/components.json';
import consoleRu from '@/locales/ru/console.json';
import dashboardTabRu from '@/locales/ru/dashboard-tab.json';
import dashboardRu from '@/locales/ru/dashboard.json';
import datagridRu from '@/locales/ru/datagrid.json';
import devicesRu from '@/locales/ru/devices.json';
import enrichmentStatisticsRu from '@/locales/ru/enrichment-statistics.json';
import headerRu from '@/locales/ru/header.json';
import homeRu from '@/locales/ru/home.json';
import licenseRu from '@/locales/ru/license.json';
import loginRu from '@/locales/ru/login.json';
import monitoringRu from '@/locales/ru/monitoring.json';
import navigationRu from '@/locales/ru/navigation.json';
import notificationRu from '@/locales/ru/notification.json';
import notificationsRu from '@/locales/ru/notifications.json';
import requestRu from '@/locales/ru/request.json';
import settingsRu from '@/locales/ru/settings.json';
import srmRu from '@/locales/ru/srm.json';
import subscriptionsRu from '@/locales/ru/subscriptions.json';
import summaryRu from '@/locales/ru/summary.json';
import systemNameLabelRu from '@/locales/ru/system-name-label.json';
import terminalRu from '@/locales/ru/terminal.json';
import translationRu from '@/locales/ru/translation.json';
import treeRu from '@/locales/ru/tree.json';
import uiRu from '@/locales/ru/ui.json';
import usersRu from '@/locales/ru/users.json';
import validationRu from '@/locales/ru/validation.json';
import widgetRu from '@/locales/ru/widget.json';
import importRu from '@/locales/ru/import.json';
import contentPackRu from '@/locales/ru/content-pack.json';
import cytoscapeRu from '@/locales/ru/cytoscape.json';
import opensearchRu from '@/locales/ru/opensearch.json';
import logsRu from '@/locales/ru/logs.json';
import rjsfRu from '@/locales/ru/rjsf.json';
import enrichmentLogsRu from '@/locales/ru/enrichment-logs.json';
import ciBulkImportRu from '@/locales/ru/ci-bulk-import.json';

// English translation imports
import _401En from '@/locales/en/401.json';
import _404En from '@/locales/en/404.json';
import accessRulesEn from '@/locales/en/access-rules.json';
import accessEn from '@/locales/en/access.json';
import attacksEn from '@/locales/en/attacks.json';
import celeryEn from '@/locales/en/celery.json';
import changePasswordEn from '@/locales/en/change-password.json';
import codemirrorEn from '@/locales/en/codemirror.json';
import componentsEn from '@/locales/en/components.json';
import consoleEn from '@/locales/en/console.json';
import dashboardTabEn from '@/locales/en/dashboard-tab.json';
import dashboardEn from '@/locales/en/dashboard.json';
import datagridEn from '@/locales/en/datagrid.json';
import devicesEn from '@/locales/en/devices.json';
import enrichmentStatisticsEn from '@/locales/en/enrichment-statistics.json';
import headerEn from '@/locales/en/header.json';
import homeEn from '@/locales/en/home.json';
import licenseEn from '@/locales/en/license.json';
import loginEn from '@/locales/en/login.json';
import monitoringEn from '@/locales/en/monitoring.json';
import navigationEn from '@/locales/en/navigation.json';
import notificationEn from '@/locales/en/notification.json';
import notificationsEn from '@/locales/en/notifications.json';
import requestEn from '@/locales/en/request.json';
import settingsEn from '@/locales/en/settings.json';
import srmEn from '@/locales/en/srm.json';
import subscriptionsEn from '@/locales/en/subscriptions.json';
import summaryEn from '@/locales/en/summary.json';
import systemNameLabelEn from '@/locales/en/system-name-label.json';
import terminalEn from '@/locales/en/terminal.json';
import translationEn from '@/locales/en/translation.json';
import treeEn from '@/locales/en/tree.json';
import uiEn from '@/locales/en/ui.json';
import usersEn from '@/locales/en/users.json';
import validationEn from '@/locales/en/validation.json';
import widgetEn from '@/locales/en/widget.json';
import importEn from '@/locales/en/import.json';
import contentPackEn from '@/locales/en/content-pack.json';
import cytoscapeEn from '@/locales/en/cytoscape.json';
import opensearchEn from '@/locales/en/opensearch.json';
import logsEn from '@/locales/en/logs.json';
import rjsfEn from '@/locales/en/rjsf.json';
import enrichmentLogsEn from '@/locales/en/enrichment-logs.json';
import ciBulkImportEn from '@/locales/en/ci-bulk-import.json';

export const NS_LIST = [
  'rjsf',
  'import',
  'tree',
  '401',
  '404',
  'settings',
  'srm',
  'users',
  'translation',
  'header',
  'navigation',
  'dashboard',
  'components',
  'notification',
  'notifications',
  'login',
  'monitoring',
  'access',
  'attacks',
  'change-password',
  'console',
  'devices',
  'home',
  'request',
  'subscriptions',
  'summary',
  'terminal',
  'ui',
  'validation',
  'widget',
  'access-rules',
  'dashboard-tab',
  'codemirror',
  'enrichment-statistics',
  'celery',
  'datagrid',
  'license',
  'system-name-label',
  'content-pack',
  'opensearch',
  'logs',
  'enrichment-logs',
  'ci-bulk-import',
];

export const resources = {
  ru: {
    import: importRu,
    tree: treeRu,
    '401': _401Ru,
    '404': _404Ru,
    settings: settingsRu,
    srm: srmRu,
    users: usersRu,
    translation: translationRu,
    header: headerRu,
    navigation: navigationRu,
    dashboard: dashboardRu,
    components: componentsRu,
    notification: notificationRu,
    notifications: notificationsRu,
    login: loginRu,
    monitoring: monitoringRu,
    access: accessRu,
    attacks: attacksRu,
    'change-password': changePasswordRu,
    console: consoleRu,
    devices: devicesRu,
    home: homeRu,
    request: requestRu,
    subscriptions: subscriptionsRu,
    summary: summaryRu,
    terminal: terminalRu,
    ui: uiRu,
    validation: validationRu,
    widget: widgetRu,
    'access-rules': accessRulesRu,
    'dashboard-tab': dashboardTabRu,
    codemirror: codemirrorRu,
    'enrichment-statistics': enrichmentStatisticsRu,
    celery: celeryRu,
    datagrid: datagridRu,
    license: licenseRu,
    'system-name-label': systemNameLabelRu,
    'content-pack': contentPackRu,
    cytoscape: cytoscapeRu,
    opensearch: opensearchRu,
    logs: logsRu,
    rjsf: rjsfRu,
    'enrichment-logs': enrichmentLogsRu,
    'ci-bulk-import': ciBulkImportRu,
  },
  en: {
    import: importEn,
    tree: treeEn,
    '401': _401En,
    '404': _404En,
    settings: settingsEn,
    srm: srmEn,
    users: usersEn,
    translation: translationEn,
    header: headerEn,
    navigation: navigationEn,
    dashboard: dashboardEn,
    components: componentsEn,
    notification: notificationEn,
    notifications: notificationsEn,
    login: loginEn,
    monitoring: monitoringEn,
    access: accessEn,
    attacks: attacksEn,
    'change-password': changePasswordEn,
    console: consoleEn,
    devices: devicesEn,
    home: homeEn,
    request: requestEn,
    subscriptions: subscriptionsEn,
    summary: summaryEn,
    terminal: terminalEn,
    ui: uiEn,
    validation: validationEn,
    widget: widgetEn,
    'access-rules': accessRulesEn,
    'dashboard-tab': dashboardTabEn,
    codemirror: codemirrorEn,
    'enrichment-statistics': enrichmentStatisticsEn,
    celery: celeryEn,
    datagrid: datagridEn,
    license: licenseEn,
    'system-name-label': systemNameLabelEn,
    'content-pack': contentPackEn,
    cytoscape: cytoscapeEn,
    opensearch: opensearchEn,
    logs: logsEn,
    rjsf: rjsfEn,
    'enrichment-logs': enrichmentLogsEn,
    'ci-bulk-import': ciBulkImportEn,
  },
};
const DEFAULT_LANGUAGE = 'ru';
const initialLanguage = localStorage?.getItem?.('language') || DEFAULT_LANGUAGE;
const configureZodLocale = (language: string) => {
  z.config(language.startsWith('en') ? zodEn() : zodRu());
};

configureZodLocale(initialLanguage);
i18next.on('languageChanged', configureZodLocale);

i18next
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    // debug: true,
    resources,
    lng: initialLanguage,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    // react i18next special options (optional)
    // override if needed - omit if ok with defaults
    /*
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true,
    }
    */
  });

export default i18next;
